import { BiLoaderAlt } from "react-icons/bi";
import { IButtonComponent } from "./interface/interface";

const Button = ({
  icon,
  selfLabel,
  isloading,
  iconClassName,
  ...props
}: IButtonComponent) => {
  return (
    <>
      <button
        {...props}
        onClick={(e) => {
          e.preventDefault();
          props.onClick?.(e);
        }}
        className={`${props.className} ${
          isloading || props.disabled ? "cursor-not-allowed" : ""
        } outline-none flex justify-center font-medium rounded-md capitalize items-center`}
      >
        {isloading ? (
          <BiLoaderAlt className="w-10 h-8 animate-spin" role="presentation" />
        ) : (
          <div className="flex items-center justify-center gap-2">
            {icon ? <div className={iconClassName}>{icon}</div> : null}
            {selfLabel}
          </div>
        )}
      </button>
    </>
  );
};

export default Button;
